export default __webpack_public_path__ + "static/media/card-project6.8ecd9660.jpg";